import { StateParams } from "@uirouter/angularjs";
import { AssetLocationHistoriesModel } from "../../models/edit/AssetLocationHistoriesModel";
import { ApplicationSetting } from "../../entities/ApplicationSetting";

export class AssetLocationHistoriesCtrl {
    assetId: number;
    dateFormat: string;
    locationHistoryGridOptions: any;
    public static $inject = ['$scope', '$stateParams', 'AssetLocationHistoriesModel']
    constructor(public $scope:any, public stateParamsService: StateParams, public model: AssetLocationHistoriesModel) {
        $scope.vm = this;
        this.assetId = stateParamsService["id"];
        this.dateFormat = ApplicationSetting.applicationSetting.dateFormat;
        this.locationHistoryGridOptions = {
            columnDefs: [{ field: 'locationName', name: 'Location Name' },
                { field: 'timeSeen', name: 'Time Seen', cellFilter: "date:'" + this.dateFormat + "'", width: 200 },
                { field: 'timeLeft', name: 'Time Left', cellFilter: "date:'" + this.dateFormat + "'", width: 200 }],
            data: [],
        };
        this.model.init(this.assetId).then((ok:boolean) => {
            this.locationHistoryGridOptions.data = this.model.allLocationHistories;
        });
    }
}
